
// on goerli
const TOKEN_ADDRESSES = {
  WETH: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
  USDC: '0x07865c6E87B9F70255377e024ace6630C1Eaa37F'
}
export { TOKEN_ADDRESSES }